export default "__VITE_ASSET__Do6Uu5Xx__"